import { STRATEGY_MAPPINGS } from '../constants/strategies';

const SUFFIX = '_event_return_actual_cumsum';

// Today's registry names for strategies the simple builder still asks for by their old names
const RENAMED = {
  strategy_favorites_0_min_fights: 'strategy_favorites',
};

const LABELS = {};
for (const [strategyName, options] of Object.entries(STRATEGY_MAPPINGS)) {
  for (const [option, column] of Object.entries(options)) {
    LABELS[column] = { group: strategyName.replace(/ Strategy$/, ''), option };
  }
}

/**
 * A readable name for a strategy column, as { group, option }.
 * The simple builder's strategies get their question and answer ("Reach Difference", "At least
 * 5 inches"); any other strategy (the language builder can choose from many more) gets its
 * column name in words, e.g. "Bet MMA picks id 130543".
 */
export function strategyLabel(column) {
  const base = String(column || '').replace(SUFFIX, '');
  const known = LABELS[column] || LABELS[`${RENAMED[base] || base}${SUFFIX}`];
  if (known) return known;
  const capper = base.match(/^strategy_bet_mma_picks_id_(\d+)$/);
  if (capper) return { group: 'Handicapper', option: `#${capper[1]}` };
  const words = base.replace(/^strategy_/, '').replace(/_/g, ' ').trim();
  return { group: words ? words.charAt(0).toUpperCase() + words.slice(1) : 'Unknown strategy', option: null };
}

/** The same as one string: "Reach Difference (At least 5 inches)". */
export function strategyDisplayName(column) {
  const { group, option } = strategyLabel(column);
  return option ? `${group} (${option})` : group;
}
